import React from "react";

const TotalSales = ({ row }) => {
  return <div>{row?.totalSales?.toLocaleString()}</div>;
};

export default TotalSales;
